import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);       // null = unknown, object = auth, false = not auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("velmonte_token");
    if (!token) { setUser(false); setLoading(false); return; }
    adminMe()
      .then((u) => setUser(u))
      .catch(() => { localStorage.removeItem("velmonte_token"); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("velmonte_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("velmonte_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
};
